module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgmain"
  }, [_vm._m(0), _vm._v(" "), (_vm.original) ? _c('div', [_c('div', {
    staticClass: "question computed"
  }, [_vm._v("来算算还有比我手续费更低的吗？")]), _vm._v(" "), _c('div', {
    staticClass: "input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contract),
      expression: "contract"
    }],
    attrs: {
      "placeholder": "请输入品种全称/交易代码/合约代码"
    },
    domProps: {
      "value": (_vm.contract)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contract = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('button', {
    on: {
      "click": _vm.searchBee
    }
  }, [_vm._v("查询手续费")])]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (!_vm.original) ? _c('div', {
    staticClass: "parts"
  }, [_c('img', {
    attrs: {
      "src": require("./success.png")
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.original) ? _c('div', [_c('form', {
    attrs: {
      "id": "form",
      "method": "post",
      "onsubmit": "return false",
      "action": "##"
    }
  }, [_c('div', {
    staticClass: "question"
  }, [_vm._v("赶紧输入信息，领取资格吧")]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientName),
      expression: "clientName"
    }],
    attrs: {
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.clientName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.clientName = $event.target.value
      }, function($event) {
        _vm.clientName = _vm.clientName.replace(/[^\u4E00-\u9FA5]/g, '')
      }]
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./peo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./tel.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./chat.png")
    }
  }), _vm._v(" "), (_vm.verifyMsg != '获取验证码') ? _c('button', {
    staticClass: "getVerCode"
  }, [_vm._v(_vm._s(_vm.verifyMsg))]) : _c('button', {
    staticClass: "getVerCode",
    on: {
      "click": _vm.getVerCode
    }
  }, [_vm._v(_vm._s(_vm.verifyMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "submittext"
  }, [_vm._v("提交成功后，工作人员会尽快与您联系。")]), _vm._v(" "), _c('div', {
    staticClass: "button"
  }, [_c('button', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("立即申请")])])])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.showInfo) ? _c('div', {
    staticClass: "model",
    on: {
      "click": _vm.closeModel
    }
  }, [_c('div', {
    staticClass: "main",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopMP.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("东航期货开户交易手续费")]), _vm._v(" "), _c('div', {
    staticClass: "blue"
  }, [_c('div', {
    staticClass: "leftInfo"
  }, [_vm._v("合约：" + _vm._s(_vm.contractInfo.instrumentidupper))]), _c('div', {
    staticClass: "rightInfo"
  }, [_vm._v("昨结算价：" + _vm._s(_vm.contractInfo.settlementprice))])]), _vm._v(" "), _c('div', {
    staticClass: "mainInfo"
  }, [_vm._m(5), _vm._v(" "), _c('p', [_c('span', [_vm._v("开仓")]), _c('span', [_vm._v(_vm._s(_vm.kc))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("平仓")]), _c('span', [_vm._v(_vm._s(_vm.pc))])]), _vm._v(" "), _c('p', [_c('span', [_vm._v("平今仓")]), _c('span', [_vm._v(_vm._s(_vm.pjc))])])]), _vm._v(" "), _c('div', {
    staticClass: "modelInputs"
  }, [_c('p', [_vm._v("赶紧输入信息，领取资格吧")]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientName),
      expression: "clientName"
    }],
    attrs: {
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.clientName)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.clientName = $event.target.value
      }, function($event) {
        _vm.clientName = _vm.clientName.replace(/[^\u4E00-\u9FA5]/g, '')
      }]
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./peo.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mobile),
      expression: "mobile"
    }],
    attrs: {
      "placeholder": "请输入手机号码"
    },
    domProps: {
      "value": (_vm.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mobile = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./tel.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inputs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./chat.png")
    }
  }), _vm._v(" "), (_vm.verifyMsg != '获取验证码') ? _c('button', {
    staticClass: "getVerCode"
  }, [_vm._v(_vm._s(_vm.verifyMsg))]) : _c('button', {
    staticClass: "getVerCode",
    on: {
      "click": _vm.getVerCode
    }
  }, [_vm._v(_vm._s(_vm.verifyMsg))])]), _vm._v(" "), _c('div', {
    staticClass: "buttonApply"
  }, [_c('button', {
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("立即领取")])])])])]) : _vm._e(), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      },
      "update:show-modal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fir"
  }, [_c('img', {
    attrs: {
      "src": require("./fir.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("本计算价格使用该品种合约上一交易日的结算价。")]), _vm._v(" "), _c('p', [_vm._v("信息仅供参考，具体费率以交易所为准。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parts"
  }, [_c('img', {
    attrs: {
      "src": require("./onepart.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parts"
  }, [_c('img', {
    attrs: {
      "src": require("./twopart.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "parts lpart"
  }, [_c('img', {
    attrs: {
      "src": require("./lpic.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plus"
  }, [_vm._v("交易所手续费+投资者保障基金"), _c('span', {
    staticClass: "redspan"
  }, [_vm._v("+1分钱")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3102abb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/dy/index.vue
// module id = 815
// module chunks = 2